import React from 'react';
import SelectBillDF from '../components/SimulatorsComponents/DefualtSimulators/SelectBillDF';

//= ========================================================================
const Sim_D01_PayBillsBillsList = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SelectBillDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D01_PayBillsBillsList;
